const video = document.querySelector('.split-page__video')
const video2 = document.querySelector('.split-page__video-2')

if (video && video2) {
    setTimeout(() => {
        if (!video2.classList.contains('hide')) {
            video2.classList.remove('show')
            video2.classList.add('hide')
            video.classList.remove('hide')
            video.classList.add('show')
        } else {
            video2.classList.remove('hide')
            video2.classList.add('show')
            video.classList.remove('show')
            video.classList.add('hide')
        }
    }, 5000)

    video.addEventListener('ended', myHandler, false)
    function myHandler(e) {
        if (!video2.classList.contains('hide')) {
            video2.classList.remove('show')
            video2.classList.add('hide')
            video.classList.remove('hide')
            video.classList.add('show')
        } else {
            video2.classList.remove('hide')
            video2.classList.add('show')
            video.classList.remove('show')
            video.classList.add('hide')
        }
        video.play()
    }
}
